module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加题目模板"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "createTemplateForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.Rules,
      "model": _vm.createTemplateParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "模板名称",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.createTemplateParams.name),
      callback: function($$v) {
        _vm.$set(_vm.createTemplateParams, "name", $$v)
      },
      expression: "createTemplateParams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "题目大类",
      "prop": "type"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.createTemplateParams.type),
      callback: function($$v) {
        _vm.$set(_vm.createTemplateParams, "type", $$v)
      },
      expression: "createTemplateParams.type"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "video"
    }
  }, [_vm._v("录音题")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "read"
    }
  }, [_vm._v("阅读理解")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "listen"
    }
  }, [_vm._v("听力题")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "模板英文"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入模板英文"
    },
    model: {
      value: (_vm.createTemplateParams.english),
      callback: function($$v) {
        _vm.$set(_vm.createTemplateParams, "english", $$v)
      },
      expression: "createTemplateParams.english"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.createTemplate
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd906d22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/modal/CreateTemplateModal.vue
// module id = 1988
// module chunks = 8